import React, { useState } from 'react';
import useAsyncEffect from 'use-async-effect';
import api, { combinedTicker } from '../../api/api';
import ChooseCompanySelect from '../users/ChooseCompanySelect';

interface StockNameLookup {
    id: string;
    displayName: string;
}

interface IProps {
    relatedStockIds: string[];
    currentStockId: string;
    onChange: (relatedStockIds: string[]) => void;
}

const RelatedStocks: React.FC<IProps> = ({ relatedStockIds, currentStockId, onChange }) => {

    const [stockNames, setStockNames] = useState<StockNameLookup[]>([]);

    useAsyncEffect(async (isMounted) => {
        const stocks = await api().getStockNames();
        if (isMounted()) {
            setStockNames(stocks.map(x => ({
                id: x.id,
                displayName: combinedTicker(x.ticker, x.exchange) + ' ' + x.companyName
            })));
        }
    }, []);

    const getDisplayName = (id: string) => {
        const found = stockNames.find(x => x.id === id);
        return found ? found.displayName : id;
    };

    const handleAdd = (item: { id: string; name: string; combinedTicker: string; companyName: string }) => {
        if (item.id === currentStockId) {
            alert('Cannot add a stock as related to itself');
            return;
        }
        if (relatedStockIds.includes(item.id)) {
            alert('This stock is already linked');
            return;
        }
        onChange([...relatedStockIds, item.id]);
    };

    const handleRemove = (id: string) => {
        onChange(relatedStockIds.filter(x => x !== id));
    };

    return (
        <div style={{ padding: '1rem 0.5rem', marginTop: '0.5rem' }}>
            <h4 style={{ margin: '0 0 8px' }}>Related Stocks</h4>
            {relatedStockIds.length > 0 && (
                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 8px' }}>
                    {relatedStockIds.map(id => (
                        <li key={id} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '4px 0' }}>
                            <span>{getDisplayName(id)}</span>
                            <button className="button-sm" onClick={() => handleRemove(id)}>Remove</button>
                        </li>
                    ))}
                </ul>
            )}
            <ChooseCompanySelect onAdd={handleAdd} buttonClassName="button-sm" />
        </div>
    );
};

export default RelatedStocks;
